
import {
  UPDATE_LOADING_STATUS,
  GET_SELECT_PANEL_INFO,
  GET_PID_PANNEL_LIST,
} from "../actions/appPannelNew";

const defVal = {
  loading: true,
  selectPanelInfo: [],
  pIdPannelList: {
    standardPanelList: [],
    customPanelList: [],
    tuyaPanelList: {},
  },
};

export default (state = defVal, action) => {
  switch (action.type) {
    case UPDATE_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading,
      });
    case GET_SELECT_PANEL_INFO:
      return Object.assign({}, state, {
        selectPanelInfo: action.selectPanelInfo,
      });
    case GET_PID_PANNEL_LIST:
      return Object.assign({}, state, {
        pIdPannelList: action.pIdPannelList,
      });
    default:
      return state;
  }
};
